/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Status_ArchivedInputs */

const en_listing_status_archived = /** @type {(inputs: Listing_Status_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived`)
};

const es_listing_status_archived = /** @type {(inputs: Listing_Status_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivado`)
};

const fr_listing_status_archived = /** @type {(inputs: Listing_Status_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivé`)
};

const de_listing_status_archived = /** @type {(inputs: Listing_Status_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviert`)
};

const ja_listing_status_archived = /** @type {(inputs: Listing_Status_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブ済み`)
};

const zh_listing_status_archived = /** @type {(inputs: Listing_Status_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已归档`)
};

const ar_listing_status_archived = /** @type {(inputs: Listing_Status_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مؤرشف`)
};

const id_listing_status_archived = /** @type {(inputs: Listing_Status_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diarsipkan`)
};

const it_listing_status_archived = /** @type {(inputs: Listing_Status_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviato`)
};

const ru_listing_status_archived = /** @type {(inputs: Listing_Status_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В архиве`)
};

const pt_listing_status_archived = /** @type {(inputs: Listing_Status_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivado`)
};

const ko_listing_status_archived = /** @type {(inputs: Listing_Status_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보관됨`)
};

/**
* | output |
* | --- |
* | "Archived" |
*
* @param {Listing_Status_ArchivedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_status_archived = /** @type {((inputs?: Listing_Status_ArchivedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Status_ArchivedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_status_archived(inputs)
	if (locale === "es") return es_listing_status_archived(inputs)
	if (locale === "fr") return fr_listing_status_archived(inputs)
	if (locale === "de") return de_listing_status_archived(inputs)
	if (locale === "ja") return ja_listing_status_archived(inputs)
	if (locale === "zh") return zh_listing_status_archived(inputs)
	if (locale === "ar") return ar_listing_status_archived(inputs)
	if (locale === "id") return id_listing_status_archived(inputs)
	if (locale === "it") return it_listing_status_archived(inputs)
	if (locale === "ru") return ru_listing_status_archived(inputs)
	if (locale === "pt") return pt_listing_status_archived(inputs)
	return ko_listing_status_archived(inputs)
});